import { render, staticRenderFns } from "./markers.vue?vue&type=template&id=21042b13&"
import script from "./markers.vue?vue&type=script&lang=js&"
export * from "./markers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports